export default "__VITE_ASSET__LfH0DCoy__"